export const MCP_SCOPES = [
  'today:read',
  'history:read',
  'history:write',
  'log:read',
  'log:write',
  'library:read',
  'library:write',
  'goals:write',
] as const;

export type McpScope = (typeof MCP_SCOPES)[number];

export const mcpOidcScopes = [
  'openid',
  'profile',
  'email',
  'offline_access',
  ...MCP_SCOPES,
] as const;

export function resolveMcpResourceUrl(baseURL: string, mcpResourceUrl?: string): string {
  if (mcpResourceUrl && mcpResourceUrl.trim().length > 0) {
    return mcpResourceUrl.trim().replace(/\/$/, '');
  }

  return `${baseURL.replace(/\/$/, '')}/mcp`;
}
